import styled, { BoxShadows, Scale, boxShadows } from '@secretescapes/falcon';
import { CommonStyledProps } from '@utils/styles.utils';
import { CustomSelect } from './CustomSelect';

interface BarProps extends CommonStyledProps {
  withTabs: boolean;
}

export const Bar = styled('div')<BarProps>`
  display: ${({ isMobile }) => (isMobile ? `grid` : `flex`)};
  gap: ${Scale.m};
  padding: ${Scale.l};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${({ isMobile }) => (isMobile ? `0` : `${boxShadows[BoxShadows.level2]}`)};

  border: ${({ withTabs, theme, isMobile }) =>
    withTabs && isMobile ? 'none' : `${theme.color.grey10} 1px solid`};

  border-radius: ${({ withTabs, isMobile }) =>
    isMobile && withTabs
      ? '0'
      : withTabs
        ? `0 ${Scale.xxs} ${Scale.xxs} ${Scale.xxs}`
        : `${Scale.xxs}`};

  .popover__parent {
    flex-grow: 1;
  }
`;

interface InputsProps {
  withFlights: boolean;
}

export const Inputs = styled('div')<InputsProps>`
  display: grid;
  grid-template-columns: ${({ withFlights }) => (withFlights ? '1fr 2fr 1fr' : '2fr 1fr')};
  grid-template-rows: auto;
  gap: ${Scale.m};
`;

export const CalendarInputs = styled('div')`
  display: flex;
  gap: ${Scale.m};
  > * {
    flex: 1;
  }
`;

export const CalendarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
  padding: ${Scale.xl} ${Scale.xxl};

  #calendar-container {
    margin: -${Scale.l};
  }
  .CalendarMonthGrid__horizontal {
    position: relative !important;
  }
  .DayPicker_transitionContainer {
    height: auto !important;
    margin-bottom: ${Scale.l} !important;
  }
`;

export const CalendarActions = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: ${Scale.l};
`;

export const CalendarOverlayContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
  overflow: hidden;
`;

export const Selection = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${Scale.m};
  padding: 0 ${Scale.m};
`;

export const StyledCustomSelect = styled(CustomSelect)`
  flex: 50%;
  min-width: 0;
`;

export const CalendarOverlayContainer = styled('div')`
  overflow-y: scroll;

  .DayPicker_weekHeaders {
    position: fixed;
    width: 100%;
  }

  .DayPicker_transitionContainer__verticalScrollable {
    height: 100% !important;
    position: unset;
    overflow: unset;
  }
`;

export const DropdownInputSkeleton = styled('div')`
  flex-grow: 1;
`;

export const DateInputsSkeleton = styled('div')`
  flex-grow: 2;
`;

export const DropdownWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding-bottom: ${Scale.m};
  li:last-child {
    border-bottom: none;
  }
`;

export const SelectionBarWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
  padding: ${Scale.m};
`;

interface PanelWrapperProps {
  removeExtraPadding?: boolean;
}

export const PanelWrapper = styled('div')<PanelWrapperProps>`
  > div:last-child {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: auto;
    top: unset;
    bottom: 0;
    ${({ removeExtraPadding }) => removeExtraPadding && `padding-bottom: 0`};

    > div:last-child {
      padding-bottom: 0;
    }
  }
`;
